var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-odo-t-m-icon-container"},[_c('div',{staticClass:"app-odo-t-m-icon",class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }